var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1171,
    viewBox: "0 0 1920 1171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_202_198)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 874.616,
    cy: 512.365,
    rx: 310.815,
    ry: 171.538,
    transform: "rotate(16.4114 874.616 512.365)",
    fill: "#8349FF",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_202_198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1223.44 500.378C1262.34 496.416 1281.58 481.38 1317.21 465.283C1386 434.21 1411.3 390.975 1481.75 363.884C1625.49 308.608 1341.72 676.422 1193.82 633.35C1100.85 606.273 934.874 434.712 1031.01 446.306C1069.4 450.937 1085.37 473.452 1122.56 484.049C1160.94 494.985 1183.74 504.421 1223.44 500.378Z",
    fill: "url(#paint0_linear_202_198)",
    fillOpacity: 0.9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_202_198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.632 431.675C519.243 436.569 470.692 464.028 423.468 527.915C327.8 657.338 886.747 698.452 808.904 556.266C759.823 466.615 688.651 425.423 593.632 431.675Z",
    fill: "#0013FF",
    fillOpacity: 0.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_202_198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.417 384.05C410.205 363.164 369.577 365.394 318.022 391.865C213.581 445.492 565.644 653.343 560.796 535.194C557.74 460.699 524.553 410.729 460.417 384.05Z",
    fill: "#00FFFF",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_202_198",
    x: 122.506,
    y: -124.188,
    width: 1504.22,
    height: 1273.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 225,
    result: "effect1_foregroundBlur_202_198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_202_198",
    x: 552.014,
    y: -91.7905,
    width: 1419.24,
    height: 1178.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 225,
    result: "effect1_foregroundBlur_202_198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_202_198",
    x: 112.414,
    y: 131.057,
    width: 1003.95,
    height: 814.528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_202_198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_202_198",
    x: -301.354,
    y: -230.001,
    width: 1462.2,
    height: 1400.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 300,
    result: "effect1_foregroundBlur_202_198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_198",
    x1: 1367.18,
    y1: 434.254,
    x2: 1133.26,
    y2: 528.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FFCDFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBg);
export default __webpack_public_path__ + "static/media/gradientBg.b9778e6e2f44bc3ceb5644e65ce72d97.svg";
export { ForwardRef as ReactComponent };